import {Routes, Route, Navigate} from "react-router-dom";
import Auth from "./authentication";
import Login from "./login";
import User from "./definitions/user";
import Content from "./definitions/content";
import ContentEdit from "./definitions/content/edit";
import Site from "./definitions/site";
import Payment from "./definitions/payment";

import 'moment/locale/tr';



import './app.css';

function App() {
    return (
        <Routes>
            <Route path="/" element={<Login/>}/>

            <Route path="/home" element={<Auth><Content/></Auth>}/>
            <Route path="/content/:contentId" element={<Auth><ContentEdit/></Auth>}/>
            <Route path="/user" element={<Auth><User/></Auth>}/>
            <Route path="/site" element={<Auth><Site/></Auth>}/>
            <Route path="/payment" element={<Auth><Payment/></Auth>}/>

            <Route path="/logout" element={<Auth><Logout/></Auth>}/>
        </Routes>
    );
}

function Logout() {
    localStorage.removeItem("token");
    return <Navigate to="/"/>;
}

export default App;
